import { Component, OnInit } from '@angular/core';
import { IWizardExportPageComponent } from '@barthauer/abc/interfaces/core/wizards/wizard-export';
import { Observable } from 'rxjs';
import { M150ExportService } from '../../m150-export.service';
import { M150WizardSettingDocument, M150WizardTransferObject } from '../../models/export.model';

@Component({
  selector: 'setting-selection-page',
  templateUrl: './setting-selection-page.component.html',
  styleUrls: ['./setting-selection-page.component.scss'],
  standalone: false,
})
export class SettingSelectionPageComponent implements OnInit, IWizardExportPageComponent {
  getDocuments$: Observable<M150WizardSettingDocument[]>;
  selectedDocument: M150WizardSettingDocument;
  transferObject: object;
  get isValid(): boolean {
    return this.selectedDocument ? true : false;
  }
  get invalidMessage(): string {
    return 'Bitte wählen Sie eine Konfiguration aus.';
  }

  constructor(m150ExportService: M150ExportService) {
    this.getDocuments$ = m150ExportService.getWizardSettingDocuments();
  }

  ngOnInit(): void {}

  onNext(): void {
    (this.transferObject as M150WizardTransferObject).settingDocument = this.selectedDocument;
  }
}
